import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'lib-form-controls',
  template: ` <p>form-controls works!</p> `,
  styles: [],
})
export class FormControlsComponent {}
